import { IsBoolean, IsDate, IsOptional, IsString } from "class-validator";

import { TransformToDate } from "../transformers/transformToDate";

export class VatValidation {
    @IsBoolean()
    public isValid: boolean;

    @IsDate()
    @TransformToDate
    public validationDate: Date;

    @IsString()
    @IsOptional()
    public errorMessage?: string;

    @IsString()
    @IsOptional()
    public businessAddress?: string;

    @IsString()
    @IsOptional()
    public businessName?: string;
}
